module.exports = __webpack_public_path__ + "img/arrow_black_long.ee1c6295.svg";